import React from 'react';
import { useIconColor } from '../../../hooks/useIconColor';

interface IconVerifiedProps {
  className?: string;
  color?: string;
}

const IconVerified: React.FC<IconVerifiedProps> = (props) => {
  const { className, color } = props;

  const { iconColor } = useIconColor();
  const fillColor = color || iconColor;

  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5153 2.95991L10.8625 3.46574C11.5617 4.48461 12.7957 4.99573 14.0106 4.76973L14.6137 4.65753C15.0451 4.57728 15.4228 4.9549 15.3425 5.38629L15.2303 5.98945C15.0043 7.20434 15.5154 8.4383 16.5343 9.13755L17.0401 9.4847C17.4019 9.733 17.4019 10.267 17.0401 10.5153L16.5343 10.8625C15.5154 11.5617 15.0043 12.7957 15.2303 14.0106L15.3425 14.6137C15.4228 15.0451 15.0451 15.4228 14.6137 15.3425L14.0106 15.2303C12.7957 15.0043 11.5617 15.5154 10.8625 16.5343L10.5153 17.0401C10.267 17.4019 9.733 17.4019 9.4847 17.0401L9.13755 16.5343C8.4383 15.5154 7.20433 15.0043 5.98945 15.2303L5.38629 15.3425C4.9549 15.4228 4.57727 15.0451 4.65753 14.6137L4.76973 14.0106C4.99573 12.7957 4.48461 11.5617 3.46574 10.8625L2.95991 10.5153C2.59812 10.267 2.59812 9.733 2.95991 9.4847L3.46574 9.13755C4.48461 8.4383 4.99573 7.20433 4.76973 5.98945L4.65753 5.38629C4.57728 4.9549 4.9549 4.57728 5.38629 4.65753L5.98945 4.76973C7.20434 4.99573 8.4383 4.48461 9.13755 3.46574L9.4847 2.95991C9.733 2.59812 10.267 2.59812 10.5153 2.95991ZM8.45407 2.25258C9.19896 1.16723 10.8011 1.16723 11.546 2.25258L11.8931 2.75842C12.3127 3.36974 13.053 3.67641 13.782 3.54081L14.3851 3.42861C15.6793 3.18786 16.8122 4.32073 16.5714 5.6149L16.4592 6.21806C16.3236 6.94699 16.6303 7.68737 17.2416 8.10692L17.7474 8.45407C18.8328 9.19896 18.8328 10.8011 17.7474 11.546L17.2416 11.8931C16.6303 12.3127 16.3236 13.053 16.4592 13.782L16.5714 14.3851C16.8122 15.6793 15.6793 16.8122 14.3851 16.5714L13.782 16.4592C13.053 16.3236 12.3127 16.6303 11.8931 17.2416L11.546 17.7474C10.8011 18.8328 9.19896 18.8328 8.45407 17.7474L8.10692 17.2416C7.68737 16.6303 6.94699 16.3236 6.21806 16.4592L5.6149 16.5714C4.32073 16.8122 3.18786 15.6793 3.42861 14.3851L3.54081 13.782C3.67641 13.053 3.36974 12.3127 2.75842 11.8931L2.25258 11.546C1.16723 10.8011 1.16723 9.19896 2.25258 8.45407L2.75842 8.10692C3.36974 7.68737 3.67641 6.94699 3.54081 6.21806L3.42861 5.6149C3.18786 4.32073 4.32073 3.18786 5.6149 3.42861L6.21806 3.54081C6.94699 3.67641 7.68737 3.36974 8.10692 2.75842L8.45407 2.25258ZM8.95834 13.4063L13.5776 8.55605L12.6724 7.69398L8.95834 11.5938L7.3276 9.88148L6.42242 10.7435L8.95834 13.4063Z"
        fill={fillColor}
      />
    </svg>
  );
};

export default IconVerified;
